// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectedTransactionsActionGroup_wrapper__w3XOC","eye":"SelectedTransactionsActionGroup_eye__guPTD","clipboardNotes":"SelectedTransactionsActionGroup_clipboardNotes__CPsvW"};